import { retrieveLaunchParams, retrieveRawInitData } from '@telegram-apps/sdk-react';

export interface TelegramUserSummary {
    id: number;
    name: string;
    username?: string;
    languageCode?: string;
}

export function getTelegramUser(): TelegramUserSummary | null {
    try {
        const lp = retrieveLaunchParams();
        const user = lp.tgWebAppData?.user;
        if (!user) {
            return null;
        }
        return {
            id: user.id,
            name: [user.first_name, user.last_name].filter(Boolean).join(' ').trim() || user.username || 'Player',
            username: user.username,
            languageCode: user.language_code,
        };
    } catch {
        return null;
    }
}

export function getRawInitData(): string | undefined {
    try {
        return retrieveRawInitData();
    } catch {
        return undefined;
    }
}
